import { getApiEnv, type ApiEnv } from './environment.ts';

const CLOUDFRONT = {
  dev: 'https://dd9olqht68i8r.cloudfront.net',
  prod: 'https://d21acfi38wn3iy.cloudfront.net',
};

// retired prod distribution still stamped in older IZ question html; its objects live on the prod one
const LEGACY_PROD_CLOUDFRONT = /^https:\/\/d2x6lu0kml9727\.cloudfront\.net\//i;

const S3_SOURCE_HOST =
  /https:\/\/online-learning-izteach-\d(?:-test)?-aws-source-bucket\.s3[.-]ap-southeast-1\.amazonaws\.com/i;

function cloudFrontBase(environment: ApiEnv): string {
  return CLOUDFRONT[environment];
}

export function combineLinkWithBucket(link: string, environment: ApiEnv = getApiEnv()): string {
  if (!link) return '';
  if (/^https?:\/\//i.test(link)) return link;
  return `${cloudFrontBase(environment)}/${link.replace(/^\/+/, '')}`;
}

// A same-origin asset has no TLS to upgrade to: the bundled demo PDF, or the LAN dev server the
// panel loads over plain http. Upgrading those to https makes the fetch fail outright.
function isSameOrigin(url: string): boolean {
  if (typeof window === 'undefined') return false;
  const origin = window.location.origin;
  return Boolean(origin) && url.indexOf(`${origin}/`) === 0;
}

export function convertURL(
  url: string,
  withoutCloudfront = false,
  environment: ApiEnv = getApiEnv(),
): string {
  if (!url) return '';
  if (isSameOrigin(url)) return url;
  const secureUrl = url.replace(/^http:\/\//i, 'https://').replace(LEGACY_PROD_CLOUDFRONT, `${CLOUDFRONT.prod}/`);
  return withoutCloudfront
    ? secureUrl
    : secureUrl.replace(S3_SOURCE_HOST, cloudFrontBase(environment));
}

export function convertUrlWithBucket(
  url: string,
  withoutCloudfront = false,
  environment: ApiEnv = getApiEnv(),
): string {
  return convertURL(combineLinkWithBucket(url, environment), withoutCloudfront, environment);
}

/** A key whose record names its bucket lives there whatever env the board runs in; a test bucket is the dev CDN. */
export function convertUrlInBucket(link: string, bucket?: string | null): string {
  if (!link || !bucket || /^https?:\/\//i.test(link)) return convertUrlWithBucket(link);
  const environment: ApiEnv = /-test-aws-source-bucket/i.test(bucket) ? 'dev' : 'prod';
  return convertURL(`${bucket.replace(/\/+$/, '')}/${link.replace(/^\/+/, '')}`, false, environment);
}
